import { SURFACE_COLORS } from '@constants/colors.ts';
import { BODY_XS_XS_MEDIUM_STYLES, BODY_XS_XS_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const UploadProgressBarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-sm, 16px);
    padding: var(--spacing-xs, 8px) var(--spacing-sm, 16px);
    border-radius: var(--border-radius-s_8, 8px);
    border: var(--border-width-sm_1, 1px) solid var(--colors-border-default, #b4b8bf);
    background: ${SURFACE_COLORS.white};
`;

export const Filename = styled.span`
    color: var(--colors-text-headings, #3e445c);
    ${BODY_XS_XS_STYLES};
    font-weight: 700;
`;

export const FileInfo = styled.span`
    color: var(--colors-text-headings, #3e445c);
    ${BODY_XS_XS_STYLES};
`;

export const UploadInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const VisualProgressBarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-sm, 16px);
`;

export const StopUploadingWrapper = styled.div<{ $isUploadCompleted: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    ${BODY_XS_XS_MEDIUM_STYLES};

    color: ${({ $isUploadCompleted }) =>
        $isUploadCompleted ? 'var(--colors-text-disabled, #B4B8BF)' : 'var(--colors-text-error, #da1e28)'};
    cursor: ${({ $isUploadCompleted }) => ($isUploadCompleted ? 'not-allowed' : 'pointer')};

    svg {
        path {
            stroke: ${({ $isUploadCompleted }) =>
                $isUploadCompleted ? 'var(--colors-text-disabled, #B4B8BF)' : 'var(--colors-text-error, #da1e28)'};
        }
    }
`;

export const UploadProgressWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    color: var(--colors-text-body, #50566e);
    ${BODY_XS_XS_STYLES};
`;

export const CompletedWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
        path {
            stroke: #22a06b;
        }
    }
`;
